import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../../assets/style/styleModalList.css';

import { ListaDeGastos } from './ListaDeGastos';
/* import { fetchConToken } from '../../helpers/fetch';
 */
import { Model } from '../../models/model';
import NumberFormat from 'react-number-format';

export const ModalListaGastos = ({ title, open, handleClose, origen, item = null }) => {

    /* const { id: pptoId } = useSelector(state => state.pptoGasto.detail) */

    const {
        id: pptoId,
        simbolo,
        separacion_miles,
        separacion_decimales
    } = useSelector(state => state.ppto.detail)

    const [expensesList, setExpensesList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [totales, setTotales] = useState({})

    const iniCargarCompras = useCallback(async () => {
        try {

            const filters = {
                ppto_id: pptoId,
                item_id: item?.id || null,
                origen
            }

            const params = (new URLSearchParams(filters)).toString()

            const params_ = {
                url: `compras/by-pptos/all/?${params}`,
            }

            //const params = (new URLSearchParams(filters)).toString()
            /* const resp = await fetchConToken(`compras/by-pptos/all/?${params_}`)
            const body = await resp.json()
*/
            const dataList = await Model.getAll(params_)
            setExpensesList(dataList.compras)
            setTotales(dataList?.totales || {})

        } catch (error) {
            console.log(error)
        }
    }, [pptoId, item?.id, origen])

    const filterList = useCallback(async ({ target }) => {
        const { value } = target

        if (value === 'todas-no-nulas') {
            const filtered = expensesList.filter(it => it.estado !== 'anulada')
            setFilteredList(filtered)
        }

        if (value === 'todas') {
            setFilteredList(expensesList)
        }

        if (value !== 'todas-no-nulas' && value !== 'todas') {
            const filtered = expensesList.filter(it => it.estado === value)
            setFilteredList(filtered)
        }

    }, [expensesList])

    useEffect(() => {
        iniCargarCompras();
    }, [iniCargarCompras])

    useEffect(() => {
        filterList({
            target: { value: 'todas-no-nulas' }
        })
    }, [expensesList, filterList])

    return (
        <Dialog
            className='dialogModalList'
            open={open}
            onClose={handleClose}
            fullScreen={true}
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                    {item ? `Gastos del ítem ${item?.nombre.toUpperCase()}` : 'Gastos del proyecto'}
                    <br />

                    {expensesList.length > 0 &&
                        <span className='text-[14px]'>{expensesList.length}{' '}compras realizadas</span>
                    }

                </h1>

                {expensesList.length > 0 &&
                    <>
                        <div className='d-flex justify-content-start' style={{ color: 'gray' }}>
                            <div>{(expensesList.filter(it => it.estado === 'emitida')).length}{' '}emitidas</div>
                            <div className='ms-2'>{(expensesList.filter(it => it.estado === 'pagada')).length}{' '}pagadas</div>
                            <div className='ms-2'>{(expensesList.filter(it => it.estado === 'anulada')).length}{' '}anuladas</div>
                        </div>
                        <select name="filter" className='mt-3 ms-2' onChange={filterList} style={{ color: 'gray', boder: '1px solid red' }}>
                            <option selected value="todas-no-nulas" style={{ color: 'gray' }}>Menos anuladas</option>
                            <option value="emitida">Emitidas</option>
                            <option value="pagada">Pagadas</option>
                            <option value="anulada">Anuladas</option>
                            <option value="todas">Todas</option>
                        </select>
                    </>
                }

                <div className='text-end me-2 mb-2'>

                    <div className='m'>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Monto Base: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalGastadoNeto) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div className=''>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Impuestos: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalImpuestos) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div className='mt-2'>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Total gastos: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalGastado) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Pagado: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalPagado) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                    <div>
                        <label className='ms-2' style={{ color: '#8e24aa', fontSize: '16px' }}>Por pagar: </label>
                        <span className='ms-2' style={{ color: '#78717A', fontSize: '15px', fontWeight: 'bold' }}>
                            <NumberFormat
                                value={parseFloat(totales.totalPorPagar) || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </span>
                    </div>

                </div>

                <ListaDeGastos
                    list={filteredList}
                    iniCargarCompras={iniCargarCompras}
                />
            </div>
        </Dialog>
    )
}
